module.exports = __webpack_public_path__ + "female-icon.6d138a06b28593417692.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/female-icon.svg
// module id = ../../../../../src/assets/images/female-icon.svg
// module chunks = main